import apiClient from './client';

// ── Types ──────────────────────────────────────────────────────────────────

export interface PasswordResetRequestPayload {
  email: string;
}

export interface PasswordResetRequestResponse {
  success: boolean;
  message: string;
}

export interface PasswordResetConfirmPayload {
  token: string;
  newPassword: string;
}

export interface PasswordResetConfirmResponse {
  success: boolean;
  message: string;
}

// ── API Functions ──────────────────────────────────────────────────────────

/**
 * Request a password reset email — always returns success to prevent
 * email enumeration (backend mirrors this behaviour).
 */
export async function requestPasswordReset(
  payload: PasswordResetRequestPayload
): Promise<PasswordResetRequestResponse> {
  const response = await apiClient.post<PasswordResetRequestResponse>(
    '/auth/password-reset-request',
    payload
  );
  return response.data;
}

/**
 * Confirm a password reset using the token from the email link.
 * Returns success on valid token + new password, throws on error.
 */
export async function confirmPasswordReset(
  payload: PasswordResetConfirmPayload
): Promise<PasswordResetConfirmResponse> {
  const response = await apiClient.post<PasswordResetConfirmResponse>(
    '/auth/password-reset-confirm',
    payload
  );
  return response.data;
}
